module.exports = __webpack_public_path__ + "ff2fcd3a5ba67b155759231e05ffd087.svg";